import type { ComponentType } from "react";
import { Link } from "react-router-dom";
import { DragScrollRow } from "@/components/DragScrollRow";
import {
  ChatIcon, CalendarIcon, PillOutlineIcon, TrendIcon, LabIcon, CardIcon,
  SyringeIcon, TruckIcon,
} from "@/components/icons";

// Horizontal quick-actions bar at the top of the dashboard — one tap to the
// tasks patients reach for most. Capped at 9 actions (help lives in the
// sidebar callout instead). Scrolls horizontally on narrow screens.
const ACTIONS: { label: string; to: string; Icon: ComponentType }[] = [
  { label: "Log dose", to: "/shots", Icon: SyringeIcon },
  { label: "Track order", to: "/treatment#orders", Icon: TruckIcon },
  { label: "Manage next shipment", to: "/messages", Icon: TruckIcon },
  { label: "Message care team", to: "/messages", Icon: ChatIcon },
  { label: "Schedule visit", to: "/visits", Icon: CalendarIcon },
  { label: "View treatment", to: "/treatment", Icon: PillOutlineIcon },
  { label: "Log progress", to: "/progress", Icon: TrendIcon },
  { label: "Lab results", to: "/labs", Icon: LabIcon },
  { label: "Billing & plan", to: "/billing", Icon: CardIcon },
];

export function QuickActions() {
  return (
    <section aria-label="Quick actions" className="mb-4">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-fh-gray mb-2">
        Quick actions
      </div>
      <DragScrollRow ariaLabel="Quick actions" className="gap-2.5 pb-1">
        {ACTIONS.map(({ label, to, Icon }) => (
          <Link
            key={label}
            to={to}
            draggable={false}
            className="shrink-0 inline-flex items-center gap-2 rounded-full border border-fh-green bg-white px-3.5 py-2 text-[13px] font-semibold text-fh-ink hover:border-fh-green-dark hover:bg-fh-sage/40 transition-colors"
          >
            <span className="text-fh-green-dark [&_svg]:w-[18px] [&_svg]:h-[18px]">
              <Icon />
            </span>
            {label}
          </Link>
        ))}
      </DragScrollRow>
    </section>
  );
}
